import { TypographyMuted } from '@talentmesh/ui/components/typography';
import { toDateAgoString } from '@/Utils/DateHelper';

interface DateTimeCaptionProps {
    label: string;
    dateAt?: string;
}
function DateTimeCaption({ label, dateAt }: DateTimeCaptionProps) {
    if (!dateAt) {
        return null;
    }

    return (
        <div className="flex flex-row items-center justify-start gap-2">
            <TypographyMuted className="text-xs">{`${label}:`}</TypographyMuted>
            <TypographyMuted className="text-xs">{toDateAgoString(dateAt)}</TypographyMuted>
        </div>
    );
}

export default DateTimeCaption;
